import PropTypes from 'prop-types'
import classNames from 'classnames'

import ArticleItem from 'components/ArticleItem'

import s from './ArticleGridBlock.module.css'

function ArticleGridBlock({
  layout = '',
  featureSource = '',
  featureArticle = [],
  featureArticleLatest = [],
  gridSource = '',
  gridArticles = [],
  gridArticlesLatest = [],
}) {
  const renderArticle = (p) => {
    const imgDetails = p.acfPost?.featuredImage?.mediaDetails
    const isLandscapeImage = imgDetails?.width > imgDetails?.height
    return (
      <ArticleItem
        key={p.slug}
        {...p}
        className={classNames(s.article, {
          [s.articleLandscape]: isLandscapeImage,
        })}
        landscapeImg={isLandscapeImage}
      />
    )
  }

  const renderFeature = () => {
    let article =
      featureSource === 'latest' ? featureArticleLatest[0] : featureArticle[0]

    if (!article || article.length < 1) return null

    return <ArticleItem className={s.feature} feature {...article} />
  }

  const renderGrid = () => {
    const articles = gridSource === 'latest' ? gridArticlesLatest : gridArticles
    if (!articles || articles.length < 1) return null

    return articles.map((p) => renderArticle(p))
  }

  return (
    <div
      className={classNames(s.container, {
        [s.containerReversed]: layout !== 'left',
      })}
    >
      <div className={s.feature}>{renderFeature()}</div>
      <div className={s.grid}>{renderGrid()}</div>
    </div>
  )
}

ArticleGridBlock.propTypes = {
  layout: PropTypes.string,
  featureSource: PropTypes.string,
  featureArticle: PropTypes.array,
  featureArticleLatest: PropTypes.array,
  gridSource: PropTypes.string,
  gridArticles: PropTypes.array,
  gridArticlesLatest: PropTypes.array,
}

export default ArticleGridBlock
